var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00075e",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 111.2 111.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.761,23.721H83.848V10.382c0-2.463-1.979-4.458-4.445-4.458H31.813c-2.469,0-4.445,1.994-4.445,4.458v13.338H4.445 C1.982,23.721,0,25.715,0,28.178v72.641c0,2.46,1.982,4.457,4.445,4.457h102.304c2.466,0,4.451-1.997,4.451-4.457V28.178 C111.212,25.715,109.228,23.721,106.761,23.721z M36.258,14.827h38.688v8.894H36.258V14.827z M102.316,96.373H8.912V32.617h93.405 V96.373z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.782,62.359h-9.737v-9.73c0-2.46-1.979-4.448-4.444-4.448c-2.47,0-4.445,1.988-4.445,4.448v9.73h-9.74 c-2.463,0-4.455,1.997-4.455,4.457c0,2.448,1.991,4.445,4.455,4.445h9.74v9.742c0,2.461,1.976,4.445,4.445,4.445 c2.466,0,4.444-1.979,4.444-4.445v-9.742h9.737c2.466,0,4.444-1.997,4.444-4.445C74.227,64.356,72.248,62.359,69.782,62.359z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalOutline);
export default __webpack_public_path__ + "static/media/medical-outline.3e4e878ee7574af788fb0c2276701a35.svg";
export { ForwardRef as ReactComponent };